// extracted by mini-css-extract-plugin
export default {"key-visual":"KeyVisual_key-visual__5x+cq","caption":"KeyVisual_caption__A2s5p"};